export type ReactiveChangeOrigin =
    | 'user'
    | 'hydrate'
    | 'programmatic'
    | 'optionsLoaded'
    | 'autoSelect'
    | 'externalPatch'
    | 'dropdownRefresh'
    | 'dropdownFinalized';

export interface ReactiveChangeOriginOptions {
    readonly origin?: ReactiveChangeOrigin;
}

const DEFAULT_CHANGE_ORIGIN: ReactiveChangeOrigin = 'programmatic';

/**
 * Small policy helper that keeps value-clearing and auto-select decisions
 * consistent across the reactive form runtime.
 */
export class ReactiveChangeOriginPolicy {
    public static resolve(origin: ReactiveChangeOrigin | undefined, fallback: ReactiveChangeOrigin = DEFAULT_CHANGE_ORIGIN): ReactiveChangeOrigin {
        return origin ?? fallback;
    }

    public static shouldClearDependentValue(origin: ReactiveChangeOrigin): boolean {
        return origin === 'user';
    }

    public static shouldAutoSelect(origin: ReactiveChangeOrigin, hasCurrentValue: boolean): boolean {
        return origin !== 'hydrate' || !hasCurrentValue;
    }
}
